var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.0608C22 6.50481 17.5224 2 12 2C6.47757 2 2 6.50481 2 12.0608C2 17.0821 5.65631 21.2445 10.4376 22V14.9697H7.8979V12.0608H10.4376V9.8438C10.4376 7.32258 11.9311 5.92898 14.2149 5.92898C15.309 5.92898 16.4537 6.12564 16.4537 6.12564V8.60158H15.1922C13.9505 8.60158 13.5624 9.37691 13.5624 10.1735V12.0608H16.3355L15.8926 14.9697H13.5624V22C18.3437 21.2459 22 17.0835 22 12.0608Z",
    fill: "#1977F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.08b8a1c6.svg";
export { ForwardRef as ReactComponent };